/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_FalseInputs */



/**
* | output |
* | --- |
* | "false" |
*
* @param {Dialogue_List_Export_Drop_Frame_FalseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_false = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_FalseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_FalseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("faux")
	if (locale === "de") return /** @type {LocalizedString} */ ("FALSCH")
	if (locale === "it") return /** @type {LocalizedString} */ ("falso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЛОЖЬ")
	if (locale === "es") return /** @type {LocalizedString} */ ("FALSO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間違い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असत्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("falso")
	return /** @type {LocalizedString} */ ("false")
});